var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var PuntosDgtFilter = /** @class */ (function (_super) {
    __extends(PuntosDgtFilter, _super);
    function PuntosDgtFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.EXP = '';
        _this.remesa = '';
        _this.fechaInicio = null;
        _this.fechaFin = null;
        _this.labels['EXP'] = _this.i18n('Expediente');
        _this.labels['remesa'] = _this.i18n('Remesa');
        _this.labels['fechaInicio'] = _this.i18n('Fecha inicio');
        _this.labels['fechaFin'] = _this.i18n('Fecha fin');
        return _this;
    }
    return PuntosDgtFilter;
}(FilterData));
export { PuntosDgtFilter };
